import React from 'react';
import HelpIcon from '@mui/icons-material/Help';
import {
  Badge,
  Box,
  ListItemIcon,
  Stack,
  SxProps,
  Theme,
  Tooltip
} from '@mui/material';

import {
  collapsibleItemSx,
  getCollapsibleButtonSx,
  StyledNavButtonOutlined
} from './Sidebar';
import { SIDEBAR_COLORS } from './sidebarTheme';

const BADGE_STYLES: SxProps<Theme> = {
  backgroundColor: 'var(--palette-semantic-background-error-primary)',
  color: 'white',
  borderRadius: '999px',
  fontSize: '10px',
  fontWeight: 500,
  minWidth: '16px',
  height: '16px',
  padding: '0 4px'
};

interface HelpCenterButtonProps {
  expanded: boolean;
  unreadMessageCount: number;
  onToggleChat: () => void;
}

const HelpCenterButton: React.FC<HelpCenterButtonProps> = ({
  expanded,
  unreadMessageCount,
  onToggleChat
}) => {
  return (
    <Tooltip
      title={expanded ? '' : 'Help Center'}
      placement="right"
      disableInteractive
    >
      <Badge
        badgeContent={expanded ? 0 : unreadMessageCount}
        color="error"
        sx={{
          width: expanded ? '100%' : 'auto',
          '& .MuiBadge-badge': expanded
            ? {}
            : {
                ...BADGE_STYLES,
                top: '-2px',
                right: '-2px',
                transform: 'none'
              }
        }}
      >
        <StyledNavButtonOutlined
          onClick={onToggleChat}
          sx={{
            ...getCollapsibleButtonSx(expanded),
            justifyContent: 'center',
            padding: expanded ? '6px 16px' : 0
          }}
        >
          <ListItemIcon sx={collapsibleItemSx}>
            <HelpIcon
              sx={{
                fontSize: '24px',
                color: (theme) => `${theme.palette.primary.main} !important`
              }}
            />
          </ListItemIcon>
          {expanded && (
            <Stack direction="column" justifyContent="center" sx={{ flex: 1 }}>
              <Stack direction="row" alignItems="center" gap="4px">
                <Box
                  component="span"
                  sx={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: SIDEBAR_COLORS.textPrimary,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  Help Center
                </Box>
                {unreadMessageCount > 0 && (
                  <Box
                    sx={{
                      ...BADGE_STYLES,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {unreadMessageCount}
                  </Box>
                )}
              </Stack>
              <Box
                component="span"
                sx={{
                  fontSize: '12px',
                  color: SIDEBAR_COLORS.textSecondary
                }}
              >
                Online
              </Box>
            </Stack>
          )}
        </StyledNavButtonOutlined>
      </Badge>
    </Tooltip>
  );
};

export default HelpCenterButton;
